import { WellnessWheelIconProps } from "../types";

export default function VitalsCategoryIcon({
  iconColorFill,
  arcColorFill,
}: WellnessWheelIconProps) {
  return (
    <g
      style={{
        animation: "scaleIn 0.2s ease-out 0.6s forwards",
        transformOrigin: `236.247px 188.253px`,
        opacity: 0,
      }}
    >
      {/* Bottom-right cutout for Heart icon */}
      <path
        d="M209.486 176.929C207.943 180.546 207.143 184.437 207.135 188.369C207.127 192.302 207.91 196.196 209.439 199.819C210.968 203.443 213.21 206.721 216.032 209.46C218.855 212.198 222.199 214.341 225.867 215.759C229.535 217.178 233.451 217.844 237.382 217.717C241.312 217.59 245.177 216.674 248.746 215.022C252.315 213.37 255.514 211.016 258.155 208.102C260.795 205.187 262.821 201.771 264.113 198.056L236.437 188.43L209.486 176.929Z"
        fill="white"
        stroke="white"
        strokeWidth="1.5"
      />

      {/* Heart icon circle - Bottom right (Vitals) */}
      <rect
        x="212.678"
        y="164.684"
        width="47.1383"
        height="47.1382"
        rx="23.5691"
        fill={iconColorFill}
      />
      <rect
        x="212.678"
        y="164.684"
        width="47.1383"
        height="47.1382"
        rx="23.5691"
        stroke={arcColorFill}
        strokeWidth="3.82202"
      />

      {/* Heart pulse icon */}
      <path
        d="M236.532 182.422C238.099 180.16 243.428 174.999 247.298 179.028C253.667 185.661 240.323 197.229 236.532 200.468C231.73 197.897 219.471 184.085 224.856 179.028C226.828 177.178 232.64 176.715 236.532 182.422ZM234.607 185.883C234.457 185.87 234.312 185.93 234.214 186.041L234.175 186.092L232.267 188.952H229.791C229.682 188.952 229.577 188.99 229.494 189.057L229.419 189.133C229.309 189.273 229.138 189.53 229.08 189.793C229.052 189.923 229.028 190.16 229.185 190.373C229.35 190.598 229.604 190.647 229.791 190.647H232.73C232.888 190.647 233.036 190.569 233.124 190.438L234.425 188.485C234.804 189.318 235.248 190.371 235.664 191.32C235.937 191.945 236.199 192.525 236.416 192.952C236.523 193.163 236.627 193.352 236.721 193.492C236.767 193.561 236.822 193.635 236.885 193.697C236.916 193.729 236.961 193.768 237.019 193.803C237.074 193.836 237.171 193.882 237.297 193.882C237.463 193.882 237.59 193.808 237.656 193.763C237.731 193.712 237.796 193.649 237.85 193.592C237.957 193.476 238.067 193.325 238.173 193.167C238.387 192.847 238.629 192.428 238.857 192.025C239.09 191.615 239.309 191.222 239.489 190.928C239.569 190.798 239.635 190.699 239.685 190.632C239.769 190.622 239.866 190.611 239.96 190.598C240.167 190.569 240.403 190.533 240.674 190.496C241.214 190.422 241.785 190.354 242.139 190.354C242.312 190.353 242.471 190.259 242.554 190.107C242.608 190.008 242.693 189.819 242.703 189.619C242.708 189.517 242.697 189.34 242.572 189.182C242.433 189.005 242.234 188.952 242.073 188.952H239.344C239.226 188.952 239.113 188.996 239.027 189.073L238.951 189.162L237.928 190.697L237.38 191.518L236.364 189.232L234.999 186.162C234.929 186.005 234.779 185.898 234.607 185.883Z"
        fill="white"
      />
    </g>
  );
}
